"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const account_1 = __importDefault(require("./account"));
const flight_1 = __importDefault(require("./flight"));
const airport_1 = __importDefault(require("./airport"));
const message_1 = __importDefault(require("./message"));
exports.store = (0, toolkit_1.configureStore)({
    reducer: {
        account: account_1.default,
        flight: flight_1.default,
        airport: airport_1.default,
        message: message_1.default,
    }
});
